<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-GROUP-HEADER' : 'EDIT-GROUP-HEADER') | translate }}</h3>
  </kendo-dialog-titlebar>

  <form novalidate [formGroup]="groupForm" class="k-form">
    <div class="row">
      <!-- name and description -->
      <div class="col-sm-6">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'NAME' | translate}} *
          </span>
          <input id="name" kendoTextBox formControlName="name" />
        </label>
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'DESCRIPTION' | translate}}
          </span>
          <textarea kendoTextArea rows="3" formControlName="description" maxlength="1024" class="w-100"></textarea>
        </label>
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'PROGRAM-EDIT-ORGANIZATION' | translate}}
          </span>
          <kendo-combobox id="programOrganizationDropdown" [data]="organizationsFiltered" [valueField]="'id'"
            [textField]="'name'" formControlName="organization" [filterable]="true"
            [itemDisabled]="organizatonItemDisabled" [readonly]="isCommunityCoordinatorRole || isProgramLeadRole"
            (filterChange)="filterOrganizations($event)">
          </kendo-combobox>
        </label>
        <label class="k-text-uppercase dark mr-2 pt-2" for="active">{{ 'ENABLED' | translate }}</label>
        <kendo-switch formControlName="active" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}">
        </kendo-switch>
      </div>
      <div class="col-sm-6">
        <span class="k-text-uppercase dark k-form-field">{{'STAFF' | translate}} *</span>
        <kendo-grid [data]="view.gridData" [hideHeader]="true" (cancel)="staffCancelHandler($event)" [pageable]="false"
          (save)="staffSaveHandler($event)" (add)="staffAddHandler($event)" (dataStateChange)="dataStateChange($event)"
          style="max-height:302px" [navigable]="true">
          <kendo-grid-messages noRecords="{{ 'NO-STAFF' | translate }}"></kendo-grid-messages>
          <kendo-grid-column field="name" [width]="70">
            <ng-template kendoGridEditTemplate>
              <kendo-combobox id="staffDropdown" [data]="staffCandidatesFiltered" [textField]="'name'"
                [valueField]="'id'" [filterable]="true" (filterChange)="filterStaffCandidates($event)"
                (close)="searchTerm=''" [(value)]="newStaffMember" [itemDisabled]="itemDisabled">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                  <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                  </span>
                </ng-template>
              </kendo-combobox>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
              <span [ngClass]="{'disabled-record-text': !dataItem.enabled || dataItem.deleted,
                'k-text-line-through': dataItem.deleted}">{{dataItem.name}}</span>&nbsp;<span
                class="disabled-record-text">{{setRecordStateText(dataItem)}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-command-column [width]="30" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem>
              <ng-container *ngIf="!dataItem.editing">
                <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}" (click)="deleteStaff(dataItem)"></i>
              </ng-container>
              <ng-container *ngIf="dataItem.editing">
                <ng-container *ngIf="newStaffMember !== null && newStaffMember !== undefined">
                  <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                    (click)="staffSaveButton.click.emit($event); dataItem.editing = false;">
                  </i>
                  &nbsp;
                </ng-container>
                <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                  (click)="staffCancelButton.click.emit($event); dataItem.editing = false;"></i>
                <button kendoGridSaveCommand #staffSaveButton class="d-none"></button>
                <button kendoGridCancelCommand #staffCancelButton class="d-none"></button>
              </ng-container>
            </ng-template>
          </kendo-grid-command-column>
          <button kendoGridAddCommand #staffAddButton class="d-none"></button>
        </kendo-grid>
        <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3"
          (click)="staffAddButton.click.emit($event)">
          {{'ADD' | translate}}<i class="far fa-user-plus"></i>
        </button>
      </div>
    </div>
  </form>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button class="k-button k-primary" [disabled]="!groupForm.valid || !groupForm.dirty || staff.length === 0"
      (click)="saveGroup()">{{
      'SAVE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>